// extracted by mini-css-extract-plugin
export var button = "ButtonText-module--button--JrxIP";
export var lightTheme = "ButtonText-module--lightTheme--qvwb0";
export var text = "ButtonText-module--text--TALn8";